import React from 'react';
import RecommendSearchWordSaveNavbar from '../RecommendSearchWordSaveNavbar';
import RecommendSearchWordSaveInfo from '../RecommendSearchWordSaveInfo';
import RecommendSearchWordSaveItemList from '../RecommendSearchWordSaveItemList';
import './RecommendSearchWordSaveWrap.scss';

const RecommendSearchWordSaveWrap = (props) => {
  const {
    form,
    recommendSearchWordSave,
    setData,
    getRecommendSearchWordItemList,
    selectRecommendSearchWordItemList,
    onSubmit,
    onDragEndSelectRecommendSearchWordItemList,
    getRecommendSearchWordItemListExcelDownload,
    typeDisabled,
    getSelectedRecommendSearchWordItemListExcelDownload,
    setRecommendSearchWordItemListExcelUpload,
  } = props;
  const { recommendSearchWordInfo, recommendSearchWordItemList } = recommendSearchWordSave;

  return (
    <div className="recommend-search-word-save-wrap">
      {/* 하단 네브바 */}
      <RecommendSearchWordSaveNavbar onSubmit={onSubmit} />

      {/* 추천 검색 키워드 정보 */}
      <RecommendSearchWordSaveInfo
        form={form}
        setData={setData}
        recommendSearchWordInfo={recommendSearchWordInfo}
        typeDisabled={typeDisabled}
      />

      {/* 추천 검색 키워드 아이템 리스트*/}
      <RecommendSearchWordSaveItemList
        recommendSearchWordItemList={recommendSearchWordItemList}
        getRecommendSearchWordItemList={getRecommendSearchWordItemList}
        selectRecommendSearchWordItemList={selectRecommendSearchWordItemList}
        onDragEndSelectRecommendSearchWordItemList={onDragEndSelectRecommendSearchWordItemList}
        getRecommendSearchWordItemListExcelDownload={getRecommendSearchWordItemListExcelDownload}
        getSelectedRecommendSearchWordItemListExcelDownload={getSelectedRecommendSearchWordItemListExcelDownload}
        setRecommendSearchWordItemListExcelUpload={setRecommendSearchWordItemListExcelUpload}
      />
    </div>
  );
};

export default RecommendSearchWordSaveWrap;
